import {
  QInput,
  QInputFrame,
  QIcon,
  QBtn,
  QSpinner } from 'quasar';

const HInput = {
  name: 'HInput',
  extends: QInput,
  props: {
    showSaveButtons: Boolean
  },
  methods: {
    discardInput () {
      this.__set(this.value, false);
      this.$nextTick(() => this.blur());
      this.$emit('discardInput', this.model);
    },
    saveInput () {
      this.__set(this.model, false);
      this.$nextTick(() => this.blur());
      this.$emit('saveInput', this.model);
    }
  },
  render (h) {
    return h(QInputFrame, {
        staticClass: 'q-input',
        props: this.frameProps,
        on: {
          click: this.__onClick,
          focus: this.__onFocus,
          paste: this.__onPaste
        }
      },
      [].concat(this.$slots.before).concat([
        this.isTextarea ? this.__getTextarea(h) : this.__getInput(h),

        (!this.disable && this.isPassword && !this.noPassToggle && (this.initialShowPassword || this.length) && h(QIcon, {
          slot: 'after',
          staticClass: 'q-if-control',
          props: {
            name: this.$q.icon.input[this.showPass ? 'showPass' : 'hidePass']
          },
          nativeOn: {
            mousedown: this.__clearTimer,
            touchstart: this.__clearTimer,
            click: this.togglePass
          }
        })) || void 0,

        (this.editable && this.keyboardToggle && h(QIcon, {
          slot: 'after',
          staticClass: 'q-if-control',
          props: {
            name: this.$q.icon.input[this.showNumber ? 'showNumber' : 'hideNumber']
          },
          nativeOn: {
            mousedown: this.__clearTimer,
            touchstart: this.__clearTimer,
            click: this.toggleNumber
          }
        })) || void 0,

        (this.isClearable && h(QIcon, {
          slot: 'after',
          staticClass: 'q-if-control',
          props: {
            name: this.$q.icon.input[`clear${this.isInverted ? 'Inverted' : ''}`]
          },
          nativeOn: {
            mousedown: this.__clearTimer,
            touchstart: this.__clearTimer,
            click: this.clear
          }
        })) || void 0,

        (this.isLoading && (this.$slots.loading
          ? h('div', {
            staticClass: 'q-if-control',
            slot: 'after'
          }, this.$slots.loading)
          : h(QSpinner, {
            slot: 'after',
            staticClass: 'q-if-control',
            props: { size: '24px' }
          }))) || void 0,

        h(QIcon, {
          slot: 'after',
          staticClass: 'q-if-control field-edit-button',
          props: {
            name: 'edit',
          },
          nativeOn: {
            
          }
        }),
        
        (this.showSaveButtons && h('div', {
          slot: 'after',
          staticClass: 'field-save-buttons row',
        }, [
          h(QBtn, {
            props: {
              icon: 'clear',
              flat: true,
              round: true,
              color: 'primary'
            },
            on: {
              click: this.discardInput
            },
            nativeOn: {
              click: (e) => e.stopPropagation()
            }
          }),
          h(QBtn, {
            props: {
              icon: 'done',
              flat: true,
              round: true,
              color: 'primary'
            },
            on: {
              click: this.saveInput
            },
            nativeOn: {
              click: (e) => e.stopPropagation()
            }
          })
        ])) || void 0,
      ]).concat(this.$slots.after).concat(this.$slots.default
        ? h('div', { staticClass: 'absolute-full no-pointer-events', slot: 'after' }, this.$slots.default)
        : void 0
      ))
  }
};

export default HInput;


// WEBPACK FOOTER //
// ./resources/assets/js/components/HInput/HInput.js